export default __webpack_public_path__ + "media/1.c6110.png";